import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { from, Observable, throwError } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { SpmedResponse } from "../shared/services/response/spmed-response";

@Injectable({
  providedIn: "root",
})
export class ReportDataService {
  private lang: string = "en";
  private baseUrl = `${environment.gateway}/pcdss/v${environment.version}/${this.lang}/reports`;

  constructor(private http: HttpClient) {}

  /**
   * Get all reports
   */
  getAll(): Observable<SpmedResponse> {
    const url = `${this.baseUrl}`;
    return this.http
      .get<SpmedResponse>(url)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }

  /**
   * Get report by qrCode
   */
  getByQrCode(qrCode: string): Observable<SpmedResponse> {
    const url = `${this.baseUrl}/${qrCode}`;

    return this.http
      .get<SpmedResponse>(url)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }

  getAllVariantsByQrCode(qrCode: string): Observable<SpmedResponse> {
    const url = `${this.baseUrl}/${qrCode}/variants`;

    return this.http
      .get<SpmedResponse>(url)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }

  getUserByQrCode(qrCode: string): Observable<SpmedResponse> {
    const url = `${this.baseUrl}/${qrCode}/user`;

    return this.http
      .get<SpmedResponse>(url)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }

  getReportStatisticsByQrCode(qrCode: string): Observable<SpmedResponse> {
    const url = `${this.baseUrl}/${qrCode}/statistics`;

    return this.http
      .get<SpmedResponse>(url)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }

  /**
   * Get drug information by report and drug name
   */
  getDrugByReportAndName(
    qrCode: string,
    name: string
  ): Observable<SpmedResponse> {
    const url = `${this.baseUrl}/${qrCode}/drugs/view`;
    const payload = {
      qrCode,
      drugName: name,
    };
    return this.http
      .post<SpmedResponse>(url, payload)
      .pipe
      // tap(data => console.log(JSON.stringify(data)))
      ();
  }
}
